import React from 'react'
import { TableCell } from '@mui/material'

const DiscountCellCollapsible = () => <TableCell colSpan={2} />

export default DiscountCellCollapsible
